import { r as registerInstance, h, H as Host, g as getElement } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import { d as debounce_1 } from './debounce-e28ac3ab.js';
import { D as DEBOUNCED_HANDLER_DELAY } from './request.constants-deb285e0.js';
import { s as sleep } from './promise-74c80706.js';
import { n as navigateWithRouter } from './utils-60b2d521.js';
import { s as store } from './pes-router-store-1a105b49.js';
import { P as PesRoute } from './pes-route-63457678.js';
import './_commonjsHelpers-ba3f0406.js';
import './isObject-33fa1780.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './noop-9247c8ef.js';
import './index-634d378a.js';

const badgeCss = ":host{display:inline-flex}.badge{box-sizing:border-box;display:flex;align-items:center;align-self:center;max-width:100%;color:#ffffff;background-color:#3dcd58}.badge *,.badge *::before,.badge *::after{box-sizing:inherit}.badge--small{min-height:20px;max-height:34px;border-radius:2px;padding:1px 5px;line-height:16px;font-size:12px}.badge--large{max-height:60px;line-height:30px;border-radius:4px;padding:0 12px;font-size:14px;font-weight:700}.badge--new{background-color:#3dcd58}.badge--featured{background-color:#42b4e6}.badge--best-value{background-color:#ffd100;color:#0f0f0f}.badge--best-performance{background-color:#e47f00}.badge--best-seller{background-color:#b10043}";

let Badge$1 = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.size = 'small';
  }
  getStyles() {
    const styles = {};
    if (this.color) {
      styles.backgroundColor = this.color;
    }
    if (this.textColor) {
      styles.color = this.textColor;
    }
    return styles;
  }
  render() {
    const hasType = !this.color && !this.textColor && this.type;
    const maxHeight = this.size === 'large' ? "60px" : "34px";
    return (h("div", { class: classnames('badge', `badge--${this.size}`, hasType && `badge--${this.type}`), style: this.getStyles() }, h("pes-ellipsis", { maxHeight: maxHeight, content: this.label })));
  }
};
Badge$1.style = badgeCss;

const BADGE_TYPE_MAP = {
  productLine: 'new',
  productsAdded: 'new',
  badgeNew: 'new',
  badgeFeatured: 'featured',
  badgeBestSeller: 'best-seller',
  badgeBestValue: 'best-value',
  badgeBestPerformance: 'best-performance',
};

const badgeWrapperCss = ":host{display:flex}";

let Badge = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.size = 'small';
  }
  getBadgeType(type) {
    if (type in BADGE_TYPE_MAP) {
      return BADGE_TYPE_MAP[type];
    }
    return '';
  }
  render() {
    return (h("pes-badge", { type: this.getBadgeType(this.type), label: this.label, size: this.size, color: this.color }));
  }
};
Badge.style = badgeWrapperCss;

const ELLIPSIS_CHAR = '…';
const ELLIPSIS_LENGTH = 3;
const isContainerOverflowed = (container) => container.scrollHeight > container.clientHeight;
const addEllipsis = (lastNode, container) => {
  lastNode.textContent = `${lastNode.textContent.trimEnd()}${ELLIPSIS_CHAR}`;
  if (isContainerOverflowed(container)) {
    const sliceFromEnd = 2 * ELLIPSIS_LENGTH;
    lastNode.textContent = `${lastNode.textContent.slice(0, -sliceFromEnd)}${ELLIPSIS_CHAR}`;
  }
};
function getRangeLastNode(childNodes, containerBottom) {
  for (let i = childNodes.length - 1; i >= 0; i -= 1) {
    const child = childNodes[i];
    const range = document.createRange();
    range.selectNodeContents(child);
    const rangeRect = range.getBoundingClientRect();
    if (rangeRect.width && rangeRect.height) {
      const lastNodeHeight = containerBottom - Math.round(rangeRect.top);
      if (lastNodeHeight > 0) {
        const fontSize = child.nodeType === Node.TEXT_NODE
          ? parseFloat(getComputedStyle(child.parentNode).fontSize)
          : parseFloat(getComputedStyle(child).fontSize);
        if (lastNodeHeight < fontSize) {
          continue;
        }
        if (child.childNodes.length) {
          return getRangeLastNode(child.childNodes, containerBottom);
        }
        return range;
      }
    }
  }
}
function getStartOffset(range, containerBottom) {
  const elem = range.startContainer;
  for (let offset = range.endOffset; offset > 0; offset -= 1) {
    range.setEnd(elem, offset);
    if (Math.round(range.getBoundingClientRect().bottom) <= containerBottom) {
      return offset;
    }
  }
}
const applyEllipsisByMaxHeight = (container, content) => {
  if (!container) {
    return;
  }
  container.innerHTML = content;
  const containerRect = container.getBoundingClientRect();
  const containerBottom = Math.round(containerRect.bottom);
  if (isContainerOverflowed(container)) {
    const lastNodeInRange = getRangeLastNode(container.childNodes, containerBottom);
    if (lastNodeInRange) {
      const lastNode = lastNodeInRange.startContainer;
      const startOffset = getStartOffset(lastNodeInRange, containerBottom);
      lastNodeInRange.detach();
      trimOverflowedContent(container, lastNode, startOffset);
      addEllipsis(lastNode, container);
    }
  }
};
const getTrimmedContentByLength = (content, maxLength) => {
  if (!maxLength) {
    return content;
  }
  const container = document.createElement('div');
  container.innerHTML = content;
  if (container.textContent.length <= maxLength) {
    return content;
  }
  const textNodes = getTextNodes(container);
  const { lastTextNode, endOffset } = getLastTextNodeInLengthWithOffset(textNodes, maxLength);
  const overflowedLength = endOffset - maxLength;
  if (overflowedLength <= 0) {
    return content;
  }
  const startOffsetToDelete = lastTextNode.textContent.length - overflowedLength;
  trimOverflowedContent(container, lastTextNode, startOffsetToDelete);
  addEllipsis(lastTextNode, container);
  return container.innerHTML;
};
function getTextNodes(node) {
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }
  return nodes;
}
function getLastTextNodeInLengthWithOffset(textNodes, length) {
  let lastTextNode = null;
  let endOffset = 0;
  for (let i = 0; i < textNodes.length; i++) {
    lastTextNode = textNodes[i];
    endOffset += lastTextNode.textContent.length;
    if (endOffset > length) {
      break;
    }
  }
  return { lastTextNode, endOffset };
}
function trimOverflowedContent(commonContainer, node, offset) {
  const rangeToDelete = document.createRange();
  rangeToDelete.selectNodeContents(commonContainer);
  rangeToDelete.setStart(node, offset);
  rangeToDelete.deleteContents();
  rangeToDelete.detach();
}

const ellipsisCss = ":host{display:block;height:100%}:host .highlight-naming{font-weight:400}:host .highlight-naming .accent{font-weight:700}.pes-ellipsis{overflow:hidden;text-align:center}.tooltip-wrapper{display:flex;align-items:center}.tooltip-wrapper-centered{justify-content:center}@media screen and (max-width: 979px){.tooltip-wrapper{justify-content:center}}";

let Ellipsis = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.hasTooltip = false;
    this.isTruncated = false;
    this.isPdpDesc = false;
    this.update = () => {
      return sleep().then(() => {
        var _a;
        applyEllipsisByMaxHeight(this.ref, this.trimmedContentByLength);
        this.isTruncated = ((_a = this.ref) === null || _a === void 0 ? void 0 : _a.innerHTML) !== this.content;
      });
    };
    this.debouncedUpdate = debounce_1(this.update, DEBOUNCED_HANDLER_DELAY);
  }
  contentOrMaxLengthDidChange() {
    this.updateTrimmedContentByLength();
  }
  triggerUpdate() {
    return this.update();
  }
  updateTrimmedContentByLength() {
    this.trimmedContentByLength = getTrimmedContentByLength(this.content, this.maxLength);
  }
  componentWillLoad() {
    this.updateTrimmedContentByLength();
  }
  componentDidLoad() {
    window.addEventListener('resize', this.debouncedUpdate);
    return this.update();
  }
  componentDidUpdate() {
    return this.update();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedUpdate);
  }
  render() {
    var _a;
    return (h("pes-tooltip-wrapper", { showTooltip: this.hasTooltip && this.isTruncated, class: classnames('tooltip-wrapper', this.wrapperModifier && `tooltip-wrapper-${this.wrapperModifier}`) }, h("div", { slot: "tooltip-activator", ref: (el) => (this.ref = el), class: classnames(this.modifier && `pes-ellipsis-${this.modifier}`, { 'pes-ellipsis': !this.isPdpDesc }, {
        'pdp-long-desc': this.isPdpDesc,
      }), style: { maxHeight: (_a = this.maxHeight) !== null && _a !== void 0 ? _a : 'none' } }), this.hasTooltip && h("div", { slot: "tooltip-content", innerHTML: this.content })));
  }
  static get watchers() { return {
    "content": ["contentOrMaxLengthDidChange"],
    "maxLength": ["contentOrMaxLengthDidChange"]
  }; }
};
Ellipsis.style = ellipsisCss;

const pesRouterLinkCss = "";

let PesRouterLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onLinkClick = (e) => {
      if (!store.get('bypass')) {
        e.preventDefault();
      }
      navigateWithRouter(this.route, e.currentTarget);
    };
  }
  connectedCallback() {
    var _a;
    this.a = this.pesLinkElement.querySelector('a');
    if (!this.url) {
      (_a = this.a) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.onLinkClick);
    }
  }
  componentWillLoad() {
    this.a = this.pesLinkElement.querySelector('a');
    if (this.url) {
      this.a.href = this.url;
    }
    else {
      this.route = new PesRoute({
        page: this.page,
        pageId: this.pageId,
        tabId: this.tabId,
        searchParams: this.urlSearchParams,
      });
      this.a.href = this.route.url;
    }
    if (this.target) {
      this.a.target = this.target;
    }
  }
  disconnectedCallback() {
    var _a;
    (_a = this.a) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.onLinkClick);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  get pesLinkElement() { return getElement(this); }
};
PesRouterLink.style = pesRouterLinkCss;

export { Badge$1 as pes_badge, Badge as pes_badge_wrapper, Ellipsis as pes_ellipsis, PesRouterLink as pes_router_link };
